import styled from "styled-components";

import { colorsPalettes, mixins, setFontVariant } from "@similarweb/styles";

export {
    StyledBulkCapError,
    StyledCounter,
    StyledPositionRelative,
    StyledTextarea,
    StyledTextareaContainer,
} from "app/pages/sales-intelligence/modules/leads-search-filters/components/filters/IndustryCodesFilter/IndustryCodesBulkInput/styles";

export const StyledBulkInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
`;

export const StyledBulkInputText = styled.p`
    ${setFontVariant("body1", colorsPalettes.carbon[400])}
    margin: 0;
`;

export const StyledSiteTagsBulkDownloadBanner = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 20px 24px;
    border-radius: 6px;
    background-color: ${colorsPalettes.blue[100]};
`;

export const StyledSiteTagsBulkDownloadBannerCopy = styled.div`
    display: flex;
    flex: 1 1 0;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
`;

export const StyledSiteTagsBulkDownloadBannerTitle = styled.p`
    margin: 0;
    ${mixins.setFontVariant("subtitle2", colorsPalettes.carbon[500])};
    font-weight: 700;
`;

export const StyledSiteTagsBulkDownloadBannerDescription = styled.div`
    margin: 0;
`;

export const StyledSiteTagsBulkDownloadBannerActions = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    align-self: center;
`;

export const StyledSiteTagsBulkInvalidNotification = styled.div`
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    padding: 12px 16px;
    border-radius: 6px;
    border: 1px solid ${colorsPalettes.red[300]};
    background-color: ${colorsPalettes.red[100]};
`;

export const StyledSiteTagsBulkInvalidNotificationText = styled.p`
    margin: 0;
    ${setFontVariant("body2", colorsPalettes.carbon[400])};
`;
